const isNodeEnv = (env: string) => {
  return process.env.NODE_ENV === env;
};

const isMasterBranch = () => {
  return process.env.CI_COMMIT_REF_NAME === "master";
};

const isProdDomain = () => {
  return (
    window.location.hostname === "us.fullscript.com" ||
    window.location.hostname === "ca.fullscript.com"
  );
};

const isSandboxDomain = () => {
  return (
    window.location.hostname === "us-snd.fullscript.io" ||
    window.location.hostname === "ca-snd.fullscript.io"
  );
};

/**
 * Verifies if the current environment is a "production" JS bundle.
 * This will evaluate to `true` for review envs, staging, sandbox and production.
 *
 * See {@link isProduction} if you want to specifically target `us.fullscript.com` or `ca.fullscript.com`
 */
export const isProductionBundle = () => {
  return isNodeEnv("production");
};

/**
 * Verifies if the current environment is `us.fullscript.com` or `ca.fullscript.com`.
 * This will only evaluate to `true` for the main production websites.
 *
 * See {@link isProductionBundle} if you want to target review envs, staging, sandbox and production
 */
export const isProduction = () => {
  return isProductionBundle() && isMasterBranch() && isProdDomain();
};

/**
 * Verifies if the current environment is `us-snd.fullscript.io` or `ca-snd.fullscript.io`.
 * This will only evaluate to `true` for the sandbox websites.
 */
export const isSandbox = () => {
  return isProductionBundle() && isMasterBranch() && isSandboxDomain();
};

/**
 * Verifies if the current environment is a `review env`, or `staging.r.fullscript.io`.
 * This will only evaluate to `true` for staging itself and review envs.
 *
 * See {@link isProductionBundle} if you want to target review envs, staging, sandbox and production
 */
export const isStaging = () => {
  return isProductionBundle() && !isProduction() && !isSandbox();
};

/**
 * Verifies if the current env is a dev environment.
 */
export const isDevelopment = () => {
  return isNodeEnv("development");
};

/**
 * Verifies if the current env is a test environment.
 * I.E. when running jest.
 */
export const isTest = () => {
  return isNodeEnv("test");
};
